import Vue from "vue";
import axios from "axios";
import store from "./store";
import { BASE_API } from "@/const";

// Request interceptor
axios.interceptors.request.use(request => {
  request.withCredentials = true;

  // if (request.params && typeof request.params.progress !== "undefined" && request.params.progress == false) {
  if (!request.params) {
    store.commit("main/pStart");
  }

  return request;
});

const checkError = (status, message, res) => {
  const statusError = [400, 403];
  if (+status == 401) {
    Vue.prototype.$error("Sesi Anda telah Habis. Silakan masuk kembali");
    store.commit("user/logout");
    window.location.href = BASE_API;
    return Promise.reject(res);
  } else if (statusError.includes(status)) {
    Vue.prototype.$warning(message);
    return Promise.reject(res);
  } else {
    Vue.prototype.$error("Terjadi kesalahan sistem. Silakan menghubungi Administrator.");

    return Promise.reject(res);
  }
};

const createData = (status, message, response) => {
  if (response && response.config && response.config.params && response.config.params.progress == false) {
    store.commit("main/pEnd");
  } else {
    Vue.prototype.$success(message);
  }
  return response;
};

// Response interceptor
axios.interceptors.response.use(
  response => {
    // eslint-disable-next-line
    if (response.config.params && response.config.params.progress == false) {
    } else {
      store.commit("main/pEnd");
    }
    if (+response.status == 201) {
      const { code = 201 } = response.data ? response.data : {};
      const { message = "Data Berhasil disimpan" } = response.data ? response.data : {};
      return createData(code, message, response);
    }
    // else
    return response;
  },
  error => {
    if (!error.response) {
      alert("Periksa koneksi internet Anda.");
    }

    const originalRequest = error.config;

    store.commit("main/pEnd");
    const { status = 500 } = error.response ? error.response : {};

    var { message = "Unknown error" } = error.response ? error.response.data : {};

    // if (typeof error.response.data == "string") {
    //   message = error.response.data;
    // }

    return checkError(status, message, error.response ? error.response.data : "", originalRequest);
  }
);
